<template>
  <tk-container class="remote" :status="status">
    <tkui-header center slot="header">
      <tk-icon slot="left-menu" @click.native="back">Return</tk-icon>
      远程设置
    </tkui-header>
    <div class="body">
      <!--<p class="name" v-if="sysTime">系统时间</p>-->
      <!--<tk-flex middle class="item" between v-if="sysTime">-->
        <!--<h2 class="itemName">系统日期</h2>-->
        <!--<p>{{sysTime}}</p>-->
      <!--</tk-flex>-->
      <!--<p class="name">租赁模式设置</p>-->
      <!--<tk-flex class="item" between @click.native="toMode">-->
        <!--<h2 class="itemName">租赁模式</h2>-->
        <!--<p>-->
          <!--<span class="val" v-if="config.lease">{{isStart ? '启用' : '停用'}}</span><tk-icon style="color:#999999;height: 16px;">return_copy</tk-icon>-->
        <!--</p>-->
      <!--</tk-flex>-->
      <p class="app-name">模式调整</p>
      <tk-flex middle class="item border" between>
        <h2 class="itemName">运行模式</h2>
        <div @click="toggle">
          <span class="val">{{state}}</span>
          <tkui-toggle v-model="value" type="switch"></tkui-toggle>
        </div>
      </tk-flex>
      <tk-flex middle class="item" between>
        <h2 class="itemName">工作状态</h2>
        <p class="val">{{machineStatus.isStart && Number(machineStatus.isStart) ? '开机' : '关机'}}</p>
      </tk-flex>
      <p class="app-name">设置开水器</p>
      <tk-flex middle class="item border" between @click.native="setRunTime">
        <h2 class="itemName">运行时间</h2>
        <div style="width: 25px;height: 100%">
          <tk-icon style="color:#999999;height: 16px;">return_copy</tk-icon>
        </div>
      </tk-flex>
      <tk-flex middle class="item border"  @click.native="setDrainTime">
        <h2 class="itemName unshrink">排水时间</h2>
        <p class="val fill right">
          <tk-icon style="color:#999999;height: 16px;">return_copy</tk-icon>
        </p>
      </tk-flex>
      <tk-flex middle class="item" between>
        <h2 class="itemName">加热温度</h2>
        <div style="position: relative;">
          <span class="val" v-if="selected">{{selected}}℃</span><tk-icon style="color:#999999;height: 16px;">return_copy</tk-icon>
          <tkui-list style="position: absolute;width: 50px;height: 30px;opacity: 0;left: 0;top: 0;">
            <tkui-list-picker @selected="select" v-model="selected" :items="temperature" label=""></tkui-list-picker>
          </tkui-list>
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  let temperature = ['']
  for (let i = 50; i <= 96; i++) {
    temperature.push(i.toString())
  }
  export default {
    data () {
      return {
        time: [week[new Date().getDay()], new Date().getHours().toString(), ':', new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes().toString()],
        value: false,
        selected: '',
        temperature: [
          temperature
        ],
        status: false,
        machineStatus: {}
      }
    },
    computed: {
      state () {
        return this.value ? '自动模式' : '非自动'
      },
      sysTime () {
        if (this.time[0] !== '' && this.time[1] !== '' && this.time[3] !== '') {
          return this.time[0] + '  ' + this.time[1] + this.time[2] + this.time[3]
        }
        return ''
      },
      machine () {
        return this.$store.state.machine
      },
      user () {
        return this.$store.state.user.objectId
      }
    },
    created () {
      this.initStatus()
    },
    methods: {
      async initStatus () {
        try {
          this.status = 'loading'
          let status = await this.$tkParse.getList('/classes/status', {
            'params': {
              'where': {
                'machine': this.machine.objectId
              }
            }
          })
          if (status[0]) {
            this.machineStatus = status[0]
            this.value = !!Number(status[0].autoRun)
            this.selected = status[0].temperatureConfig.toString()
          }
          this.status = false
        } catch (e) {
          this.status = 'error'
          this.$tkGlobal.toast.add('获取设备状态失败')
        }
      },
      back () {
        this.$back()
      },
//      toMode () {
//        this.$push('/lease')
//      },
      async toggle () {
        try {
          let res = await this.$tkParse.getData(`/classes/machine/${this.machine.objectId}`)
          if (!res.online) {
            this.value = !this.value
            this.status = false
            this.$tkGlobal.toast.add('设备离线，无法设置')
            return
          }
          this.status = 'waiting'
          await this.$cloudAjax.post('/index/setConfig', {
            'machine': this.machine.objectId,
            'status': {
              'autoRun': this.value ? '01' : '00'
            },
            'type': '运行模式',
            'user': this.user,
            'deviceId': this.machine.deviceId
          })
          this.status = false
          this.$tkGlobal.toast.add('设置成功')
        } catch (e) {
          this.value = !this.value
          this.status = false
          this.$tkGlobal.toast.add('设置失败')
        }
      },
      setRunTime () {
        this.$push('/runtime')
      },
      setDrainTime () {
        this.$push('/drain')
      },
      async select () {
        if (!this.selected) return
        try {
          let res = await this.$tkParse.getData(`/classes/machine/${this.machine.objectId}`)
          if (!res.online) {
            this.selected = this.machineStatus.temperatureConfig.toString() || '50'
            this.status = false
            this.$tkGlobal.toast.add('设备离线，无法设置')
            return
          }
          this.status = 'waiting'
          await this.$cloudAjax.post('/index/setConfig', {
            'machine': this.machine.objectId,
            'status': {
              'temperatureConfig': Number(this.selected)
            },
            'type': '加热温度',
            'user': this.user,
            'deviceId': this.machine.deviceId
          })
          this.status = false
          this.$tkGlobal.toast.add('设置成功')
        } catch (e) {
          this.selected = this.machineStatus.temperatureConfig || '50'
          this.status = false
          this.$tkGlobal.toast.add('设置失败')
        }
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .body{
    .app-name{
      padding: 0 15px;
      font-size: 14px;
      color: #999999;
      height: 33px;
      line-height: 33px;
      margin-bottom: 0 !important;
    }
    .item{
      padding: 15px;
      background: #ffffff;
      .itemName{
        font-size: 16px;
        color: #333333;
      }
      .right{
        text-align: right;
      }
      .val{
        font-size: 14px;
        color: #666666;
        margin-bottom: 0!important;
      }
    }
    .border{
      border-bottom: 1px solid #F1F5F8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/detail/remote.vue